import { colors, ORDER_ISSUE_TYPES } from '@nandosaus/constants';
import { findLast, map } from 'lodash';
import { useRootStore } from '@nandosaus/state-management';

import { Flex } from '../../grid';
import { Icon } from '../../icons';
import { P } from '../../typography';

const SelectIssue = () => {
  const { OrderHelpStore, MemberStore } = useRootStore();

  const handleSelectOrderIssue = orderIssue => {
    OrderHelpStore.setOrderIssue(orderIssue);
    OrderHelpStore.goForward();
  };

  const isGuestFlow = !MemberStore.isSignedIn;
  return (
    <>
      <P variant={3} mb="1">
        Get help with past orders. You can request a refund or leave us a comment. We&#39;ll get back to you as fast as
        we can.
      </P>
      <Flex flexDirection="column" backgroundColor="white" borderTop={isGuestFlow ? `1px solid ${colors.grey100}` : ''}>
        {map(ORDER_ISSUE_TYPES, (issue, index) => {
          const showBorder = isGuestFlow ? true : issue !== findLast(ORDER_ISSUE_TYPES);

          return (
            <Flex
              as="button"
              justifyContent="space-between"
              alignItems="center"
              py={1}
              mx={isGuestFlow ? 0 : 1}
              key={index}
              borderBottom={showBorder ? `solid 1px ${colors.grey100}` : 0}
              onClick={() => handleSelectOrderIssue(issue)}
              color="currentColor"
            >
              <P variant={2}>{issue}</P>
              <Icon name="chevronRight" width="1rem" />
            </Flex>
          );
        })}
      </Flex>
    </>
  );
};

export { SelectIssue };
